import React, { useEffect, useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";

const initialForm = {
  prenume: "",
  nume: "",
  telefon: "",
  email: "",
  oras: "",
  judet: "",
  tara: "România",
  cnp: "",
  serie_numar_ci: "",
  adresa: "",
  tip_cotizatie: "lunar",
  data_start: "",
  data_sfarsit: "",
  status_membru: "activ",
  timestamp: new Date().toISOString(),
};

const AddMemberModal = ({ show, onHide, onSave, initialData }) => {
  const [form, setForm] = useState(initialForm);

  useEffect(() => {
    if (initialData) {
      setForm(initialData);
    } else {
      setForm(initialForm);
    }
  }, [initialData, show]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = () => {
    onSave(form);
    // nu resetez aici, se face in Membri.jsx la inchidere modal
  };

  return (
    <Modal show={show} onHide={onHide} size="lg" backdrop="static">
      <Modal.Header closeButton>
        <Modal.Title>{initialData ? "Editează Membru" : "Adaugă Membru"}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <div className="row">
            {[
              "prenume",
              "nume",
              "telefon",
              "email",
              "oras",
              "judet",
              "cnp",
              "serie_numar_ci",
              "adresa",
            ].map((field) => (
              <div className="col-md-6 mb-3" key={field}>
                <Form.Label>
                  {field
                    .replace(/_/g, " ")
                    .replace(/\b\w/g, (l) => l.toUpperCase())}
                </Form.Label>
                <Form.Control
                  type="text"
                  name={field}
                  value={form[field]}
                  onChange={handleChange}
                />
              </div>
            ))}

            <div className="col-md-6 mb-3">
              <Form.Label>Țara</Form.Label>
              <Form.Select name="tara" value={form.tara} onChange={handleChange}>
                <option value="România">România</option>
                <option value="Diaspora">Diaspora</option>
              </Form.Select>
            </div>

            <div className="col-md-6 mb-3">
              <Form.Label>Tip Cotizație</Form.Label>
              <Form.Select
                name="tip_cotizatie"
                value={form.tip_cotizatie}
                onChange={handleChange}
              >
                <option value="lunar">Lunar</option>
                <option value="anual">Anual</option>
              </Form.Select>
            </div>

            <div className="col-md-6 mb-3">
              <Form.Label>Data început</Form.Label>
              <Form.Control
                type="date"
                name="data_start"
                value={form.data_start}
                onChange={handleChange}
              />
            </div>

            <div className="col-md-6 mb-3">
              <Form.Label>Data sfârșit</Form.Label>
              <Form.Control
                type="date"
                name="data_sfarsit"
                value={form.data_sfarsit}
                onChange={handleChange}
              />
            </div>

            <div className="col-md-6 mb-3">
              <Form.Label>Status Membru</Form.Label>
              <Form.Select
                name="status_membru"
                value={form.status_membru}
                onChange={handleChange}
              >
                <option value="activ">Activ</option>
                <option value="inactiv">Inactiv</option>
              </Form.Select>
            </div>
          </div>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Închide
        </Button>
        <Button variant="primary" onClick={handleSubmit}>
          Salvează
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default AddMemberModal;
